import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePickerComp from "themes/elements/DatePicker";
import InputComp from "themes/elements/Input";
import ModalComp from "themes/elements/Modal";
import TextAreaComp from "themes/elements/TextArea";
import ModalFooter from "../modalFooter";

function Experience({ isEdit, open, setOpen, handleSave, seletedItem }) {
  const { selectedCounsilor, editQualification, expChangeLoading } =
    useSelector((state) => state.counsilor);
  const [experience, setExperience] = useState({
    title: "",
    startDate: "",
    endDate: "",
    subTitle: "",
  });
  const handleChangeDate = (field, value) => {
    // Check if the value is a valid date, specifying the expected format
    if (dayjs(value, "DD-MM-YYYY").isValid()) {
      const formattedDate = dayjs(value, "DD-MM-YYYY").format("YYYY-MM-DD");
      setExperience((prev) => ({ ...prev, [field]: formattedDate }));
    } else {
      setExperience((prev) => ({ ...prev, [field]: "" })); // Optionally clear the invalid date
    }
  };

  const reformatDate = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    return `${parts[2]}-${parts[1]}-${parts[0]}`; // Correcting the order to Year-Month-Day
  };

  const handleChange = (field, value) => {
    if (field === "startDate" || field === "endDate") {
      value = reformatDate(value);
    }
    setExperience({ ...experience, [field]: value });
  };

  const isValid = () => {
    return (
      experience.title.trim() &&
      experience.startDate &&
      experience.endDate &&
      experience.subTitle.trim()
    );
  };

  const handleFormSave = () => {
    if (isValid()) {
      handleSave(isEdit ? "update" : "create", experience, "experience");
    } else {
      toast.warn("Please fill all the fields.");
    }
  };
  useEffect(() => {
    if (editQualification && isEdit && seletedItem) {
      setExperience({
        title: seletedItem.title,
        startDate: seletedItem.exp_start_date,
        endDate: seletedItem.exp_end_date,
        subTitle: seletedItem.sub_title,
        recordId: seletedItem?.councilor_exp_info_id,
      });
    } else {
      setExperience({
        title: "",
        startDate: "",
        endDate: "",
        subTitle: "",
      });
    }
  }, [seletedItem, isEdit, editQualification, open]);

  const disableStartDate = (current) => {
    if (experience.endDate) {
      return (
        current.isAfter(dayjs().endOf("day")) ||
        current.isAfter(dayjs(experience.endDate, "YYYY-MM-DD"))
      );
    }
    return current.isAfter(dayjs().endOf("day"));
  };

  const disableEndDate = (current) => {
    if (experience.startDate) {
      return (
        current.isAfter(dayjs().endOf("day")) ||
        current.isBefore(dayjs(experience.startDate, "YYYY-MM-DD"))
      );
    }
    return current.isAfter(dayjs().endOf("day"));
  };

  return (
    <ModalComp
      title="Experience"
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setOpen(false)}
          handleSecondaryBtn={handleFormSave}
          secondaryBtnLoading={expChangeLoading}
          primaryBtnText="Cancel"
          secondaryBtnText="Save"
          primaryBtnVariant="secondary"
        />
      }
      open={open}
      setOpen={setOpen}
    >
      <div className="flex gap-4 flex-column">
        <InputComp
          showCount
          maxLength={100}
          layoutClass="w-full"
          value={experience.title}
          onChange={(e) => handleChange("title", e.target.value)}
          placeholder="Job role"
          label="Job role"
        />
        <div className="flex gap-4 align-center">
          <div className="flex flex-column w-full">
            <label className={`${"input-label"} mb-2`}>From </label>
            <DatePickerComp
              label="From"
              disabledDate={disableStartDate}
              format="DD-MM-YYYY"
              value={
                experience.startDate
                  ? dayjs(experience.startDate).format("DD-MM-YYYY")
                  : null
              }
              onChange={(date) => handleChangeDate("startDate", date)}
            />
          </div>
          <div className="flex flex-column w-full">
            <label className={`${"input-label"} mb-2`}>To </label>
            <DatePickerComp
              disabledDate={disableEndDate}
              label="To"
              format="DD-MM-YYYY"
              value={
                experience.endDate
                  ? dayjs(experience.endDate).format("DD-MM-YYYY")
                  : null
              }
              onChange={(date) => handleChangeDate("endDate", date)}
            />
          </div>
        </div>
        <TextAreaComp
          maxValue={200}
          layoutClass="w-full"
          value={experience.subTitle}
          onChange={(e) => handleChange("subTitle", e.target.value)}
          placeholder="Description"
          label="Description"
        />
      </div>
    </ModalComp>
  );
}

export default Experience;
